import React, {useEffect, useState} from 'react';
import {showError} from "../../../utils/NotificationUtils";
import {useIntegrationsContext} from "../../../api/integrations/IntegrationsContext";
import {GetIntegrationTriggerListProps} from "../../../api/integrations/IntegrationsDTO";
import {useHistory, useParams} from "react-router";
import {Loader} from "../../ui/Loader";
import {InfoBanner} from "../../ui/InfoBanner";
import {AppButton} from "../../ui/AppButton";
import {pathParams} from "path-params";
import {Routes} from "../../../constants/Routes";
import {makeStyles} from "@mui/styles";
import {IntegrationEventsList} from "../IntegrationEventsList";

const useStyles = makeStyles(() => ({
    root: {
        padding: 40,
    },
    container: {
        maxWidth: 1100,
        margin: "0 auto"
    }
}));

export function IntegrationActionsListRoot() {
    const {IntegrationsApi} = useIntegrationsContext();
    const [data, setData] = useState<GetIntegrationTriggerListProps[]>([]);
    const [loading, setLoading] = useState(true);
    const params: any = useParams();
    const history = useHistory();
    const classes = useStyles();

    useEffect(() => {
        IntegrationsApi.getIntegrationActionsList({params: {integrationId: params.id}}).then(res => {
            setData(res.payload.list);
            setLoading(false)
        }).catch(err => {
            setLoading(false);
            showError(err)
        })
    }, [IntegrationsApi, params]);
    return (
        <div className={classes.root}>
            {loading ? <Loader/> : (
                <div className={classes.container}>
                    <div>
                        <h3>Action</h3>
                    </div>
                    {data.length === 0 ? <InfoBanner title="Add Your First Action"
                                                     description="Actions POST or send data to your API, to find, update, or create items using data from Triggers and previous Actions in the Zap. Add actions for everything users can find, add, or update in your app."/> : (
                        <IntegrationEventsList  data={data}/>
                    )}
                    <AppButton size="large"
                               sx={{mt: 2}}
                               onClick={() => history.push(pathParams(Routes.IntegrationEditorActionAdd, {id: params.id}))}>Add
                        Action</AppButton>
                </div>
            )}
        </div>
    );
}

